import React, { useEffect, useState, createElement } from 'react';
export function RegaloPage() {
  const [isLoaded, setIsLoaded] = useState(false);
  useEffect(() => {
    // Load GHL form embed script
    const script = document.createElement('script');
    script.src = 'https://link.msgsndr.com/js/form_embed.js';
    script.async = true;
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);
  return <div className="min-h-screen w-full bg-gradient-to-b from-blue-50 to-white" data-id="element-2434">
      <div className="container mx-auto px-4 py-12 max-w-4xl" data-id="element-2435">
        <div className="bg-white rounded-lg shadow-lg overflow-hidden relative" style={{
        minHeight: '500px'
      }} data-id="element-2436">
          {!isLoaded && <div className="absolute inset-0 flex flex-col items-center justify-center gap-4 bg-white z-10" data-id="element-2437">
              <div className="w-10 h-10 border-4 border-blue-200 border-t-blue-600 rounded-full animate-spin" data-id="element-2438" />
              <p className="text-sm text-gray-400" data-id="element-2439">Cargando formulario…</p>
            </div>}
          <iframe src="https://api.leadconnectorhq.com/widget/survey/iiMWY9kvnXEvpE11rfro" style={{
          border: 'none',
          width: '100%',
          minHeight: '500px',
          opacity: isLoaded ? 1 : 0,
          transition: 'opacity 0.3s ease-in-out'
        }} scrolling="no" id="iiMWY9kvnXEvpE11rfro" title="survey" onLoad={() => setIsLoaded(true)} data-id="element-2440" />
        </div>
        <div className="mt-8 text-center text-sm text-gray-500" data-id="element-2441">
          <p data-id="element-2442">
            Tu información está segura y nunca será compartida con terceros.
          </p>
        </div>
      </div>
    </div>;
}